export var NavigationRoutes;
(function (NavigationRoutes) {
    NavigationRoutes["HOMEPAGE"] = "/";
    NavigationRoutes["BROWSE_POSTERS"] = "/posters/all";
    NavigationRoutes["BROWSE_COLLECTIONS"] = "/browse-collections";
    NavigationRoutes["BROWSE_BRANDS"] = "/browse-brands";
    NavigationRoutes["JOIN_DISPLATE_CLUB"] = "/join-displate-club";
    NavigationRoutes["LIMITED_EDITION"] = "/limited-edition";
    NavigationRoutes["WHATS_DISPLATE"] = "/whats-a-displate";
    NavigationRoutes["LUMINO"] = "/lumino";
    NavigationRoutes["ACCESSORIES"] = "/accessories";
    NavigationRoutes["GIFT_CARD"] = "/gift-card";
})(NavigationRoutes || (NavigationRoutes = {}));
//# sourceMappingURL=navigationRoutes.js.map